import { loadStripe as stripeLoad } from '@stripe/stripe-js';

let failed = false;
const listeners = new Set();
export const subscribeStripeLoad = listener => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
export const hasStripeLoadFailed = () => failed;

// Elements accepts null. A failed download must not become an unhandled rejection.
export async function loadStripe(...args) {
  try {
    const stripe = await stripeLoad(...args);
    failed = !stripe;
    listeners.forEach(listener => listener());
    return stripe;
  } catch {
    failed = true;
    listeners.forEach(listener => listener());
    return null;
  }
}
